<template>
  <div class="h-screen flex items-center justify-center">
    <LoadingAnimation />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import LoadingAnimation from '@/components/UILibrary/loading-animation.vue'

@Component({
  name: 'FullScreenLoading',
  components: { LoadingAnimation }
})
export default class extends Vue {}
</script>

<style></style>
